import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'tidy-first-job-amount',
  template: `
    @if (shows) {
      @switch (variant) {
        @case ('short') {
          <tidy-row>
            <tidy-text
              [body]="('First job: ' | translate) + (amount | tcurrency) +
              (bonus > 0 ? ' + ' + (bonus | tcurrency) + (' Bonus' | translate) : '')">
            </tidy-text>
          </tidy-row>
        }
        @case ('confirm') {
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="('First job for this client: ' | translate) +
              (amount | tcurrency) +
              (' (your New Client Rate). Your Repeat Client Rate applies after that job is done.' | translate)">
            </tidy-text>
          </tidy-row>
        }
        @default {
          <tidy-row>
            <tidy-text
              [body]="('Any discounts you offer apply. First job: ' | translate) + (amount | tcurrency) +
              (bonus > 0 ? ' + ' + (bonus | tcurrency) + (' Bonus' | translate) : '')">
            </tidy-text>
          </tidy-row>
        }
      }
    }
  `,
  styles: [`
    tidy-first-job-amount {
      display: block;
    }

    /* tidy-card drops the padding of a tidy-row that is an only child, but this row sits among the card's rows. */
    tidy-card > section > tidy-first-job-amount > tidy-row:only-child {
      padding-bottom: 5px;
    }
  `],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class FirstJobAmountComponent {
  // Read on every check, not copied in ngOnInit: claim-job replaces its cleaning after a refresh.
  @Input() cleaning: any;
  @Input() variant: 'default' | 'short' | 'confirm' = 'default';

  get shows(): boolean {
    return this.cleaning?.type === 'plan'
      && this.cleaning?.billing_type === 'flat_rate'
      && typeof this.cleaning?.first_job_amount === 'number'
      && this.cleaning.first_job_amount < this.cleaning.cleaning_amount;
  }

  // first_job_amount includes the bonus, shown apart as the price is ("$70 + $10 Bonus").
  get amount(): number {
    return this.cleaning.first_job_amount - this.bonus;
  }

  get bonus(): number {
    return this.cleaning.bonus_amount || 0;
  }
}
